import {Route, Switch} from 'react-router-dom';
import Notification from './notification/Notification.container';
import Dashboard from './dashboard/Dashboard.component';
import Security from './security/Security.component';
import CorporateCommunicated from './corporateCommunicated/CorporateCommunicated.container';
import SideBar from '../component/sideBar/SideBar.component';
import FindTec from './findTec/FindTec.component';
import Product from './products/Product.container';
import Store from './store/Store.container';
import { AuthorizationOption } from "../authorization/Authorization";
import PrivateRouter from './PrivateRoute';
import { AUTORIZATION } from '../enum/authorization/Authorization';
import Rating from './rating/Assessment.container';
import Schedule from "./scheduleMaintenance/Schedule.component";
import PatioManagement from "./patioManagement/PatioManagement.container";
import TaskContainer from './task/Task.container';

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={() => <SideBar />} />
      <Route path="/dashboard" component={() => <Dashboard />} />
      <PrivateRouter path="/notificacao" component={() => <Notification />} access={AuthorizationOption(AUTORIZATION.NOTIFICATION)} />
      <PrivateRouter path="/seguranca" component={() => <Security />} access={AuthorizationOption(AUTORIZATION.SAFETY)} />
      <PrivateRouter path="/comunicado-corporativo" component={() => <CorporateCommunicated />} access={AuthorizationOption(AUTORIZATION.COMMUNICATIONS) || AuthorizationOption(AUTORIZATION.COMMUNICATIONS_APP)} />
      <PrivateRouter path="/cenco-geo" component={() => <FindTec />} access={AuthorizationOption(AUTORIZATION.CENCO_GEO)} />
      <PrivateRouter path="/produtos" component={() => <Product />} access={true} />
      <PrivateRouter path="/loja" component={() => <Store />} access={true} />
      <PrivateRouter path="/avaliacao-loja" component={() => <Rating />} access={AuthorizationOption(AUTORIZATION.MODULO_AVALIACAO_LOJA)} />
      <PrivateRouter path="/manutencao-horarios" component={() => <Schedule />} access={AuthorizationOption(AUTORIZATION.MANUTENCAO_HORARIO)} />
      <PrivateRouter path="/gestao-de-patio" component={() => <PatioManagement />} access={AuthorizationOption(AUTORIZATION.GESTAO_PATIO)} />
      <PrivateRouter path="/task" component={() => <TaskContainer />} access={AuthorizationOption(AUTORIZATION.TASKS)} />
      <Route component={() => <>NotFoundRedirect</>} />
    </Switch>
  );
};

export default Routes;
